import type { PspKycSetting } from "features/pspKycSettings/types";

export type KycTypesMap = Record<string, number | string>;

export type CountryLookup = ReadonlyMap<string, string>;

export const formatPspLabel = (setting: PspKycSetting) =>
    setting.PSP || 'All PSPs';

export const formatMorLabel = (setting: PspKycSetting) =>
    setting.MOR || 'All domains';

export const formatMethodLabel = (setting: PspKycSetting) => {
    if (setting.paymentMethodName) {
        return setting.paymentMethodName;
    }
    if (setting.methodId) {
        return String(setting.methodId);
    }
    return 'All methods';
};

export const formatKycProviderLabel = (setting: PspKycSetting) =>
    setting.kycProvider ?? '';

export const formatKycTypeLabel = (
    setting: PspKycSetting,
    kycTypesMap: KycTypesMap
) => {
    const entry = Object.entries(kycTypesMap)
        .find(([, id]) => Number(id) === Number(setting.kycTypeId));
    return entry?.[0] ?? String(setting.kycTypeId);
};

export const formatCountryLabel = (
    setting: PspKycSetting,
    countryByIso: CountryLookup
) => {
    if (!setting.countryIso2) {
        return 'All countries';
    }
    return countryByIso.get(setting.countryIso2) ?? setting.countryIso2;
};
